import { useRef } from 'react';
export function useFollow(value) {
    const ref = useRef(value);
    ref.current = value;
    return ref;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlRm9sbG93LmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInVzZUZvbGxvdy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsTUFBTSxFQUFFLE1BQU0sT0FBTyxDQUFBO0FBRTlCLE1BQU0sVUFBVSxTQUFTLENBQUksS0FBUTtJQUNwQyxNQUFNLEdBQUcsR0FBRyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUE7SUFDekIsR0FBRyxDQUFDLE9BQU8sR0FBRyxLQUFLLENBQUE7SUFDbkIsT0FBTyxHQUFHLENBQUE7QUFDWCxDQUFDIn0=